<ng-container *ngIf="isShowingResults === false">
  <div class="comment" *ngIf="isSubmitted && comment" [ngStyle]="{'color': color}">
    <div class="title">{{ "__CONFERENCE_COMMENT__" | translate }}:</div>
    <div>{{ comment }}</div>
  </div>
  <div class="option" *ngFor="let option of options; let i = index"
       (click)="choose(option)"
       [ngClass]="{
        'multiselect': isMultiselect,
        'completed': isSubmitted,
        'selected': option.isSelected && !(type=== 'quiz' && _card.isNoCorrect),
        'correct-img': isSubmitted && type=== 'quiz' && (_card.isNoCorrect || option.item.isValid) && !option.isSelected,
        'wrong-img': isSubmitted && type=== 'quiz' && !_card.isNoCorrect && !option.item.isValid && !option.isSelected,
        'neutral': isSubmitted && type=== 'quiz' && _card.isNoCorrect && option.isSelected,
        'correct': isSubmitted && type=== 'quiz' && !_card.isNoCorrect && option.isSelected && option.item.isValid,
        'wrong': isSubmitted && type=== 'quiz' && !_card.isNoCorrect && option.isSelected && !option.item.isValid
     }">
    <img *ngIf="type === 'quiz' || isMultiselect"/>
    <div>{{ option.item.text }}</div>
  </div>
  <app-card-button *ngIf="!isSubmitted && selectedOptionsCount() > 0"  [text]="'__INTERACTION_SUBMIT_RESPONSE__' | translate"  (onSubmit)="submit()"
                   [ngClass]="{disabled: !isValid()}"
  ></app-card-button>
  <app-card-button *ngIf="isEnableSwitchViews && isSubmitted" (click)="showResults()"
                   [tightLayout]="true" [text]="'__INTERACTION_DISPLAY_STATISTICS__' | translate"
                   [color]="'rgba(168, 150, 246, 0.5)'" [colorInverse]="'white'"></app-card-button>
</ng-container>
<ng-container *ngIf="isShowingResults === true && results">
  <app-card-results
    [results]="results"
  ></app-card-results>
  <app-card-button *ngIf="isEnableSwitchViews"
                   (click)="hideResults()"
                   [tightLayout]="true" [text]="'__INTERACTION_DISPLAY_MY_ANSWERS__' | translate"
                   [color]="'rgba(168, 150, 246, 0.5)'" [colorInverse]="'white'"></app-card-button>
</ng-container>
